exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i[data-v-217255d0]{color:#ffc72c;font-size:30px}div.week-selector[data-v-217255d0]{padding:8px 0}div.week-selector>div[data-v-217255d0]{color:#fff;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}div.week-selector>div[data-v-217255d0],div.week-selector i[data-v-217255d0]{display:-webkit-box;display:-ms-flexbox;display:flex}.fa-chevron-left[data-v-217255d0],.fa-chevron-right[data-v-217255d0]{cursor:pointer}", ""]);

// exports
